"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalPortalContainer = exports.ModalPortalProvider = exports.ModalPortalContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
exports.ModalPortalContext = (0, react_1.createContext)({ elementRef: null });
function ModalPortalProvider(_a) {
    var children = _a.children, elementRef = _a.elementRef;
    return react_1.default.createElement(exports.ModalPortalContext.Provider, { value: { elementRef: elementRef } }, children);
}
exports.ModalPortalProvider = ModalPortalProvider;
function useModalPortalContainer() {
    var context = (0, react_1.useContext)(exports.ModalPortalContext);
    return context.elementRef;
}
exports.useModalPortalContainer = useModalPortalContainer;
//# sourceMappingURL=context.js.map